import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-10 mx-auto" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-warning mb-4",
  role: "alert"
}
const _hoisted_4 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_6 = { class: "card bg-light col-xl-6" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "form-floating mb-3" }
const _hoisted_9 = {
  key: 2,
  class: "mt-3"
}

import { ref, computed } from "vue";
    import NumberInput from "../common/NumberInput.vue";
    import { EquityReleaseRateResponse } from "@/guiide/ts/response/equityReleaseRateResponse";
    import { formatter } from "@/db/ts/formatter";
    import HttpStatusCode from "@/shared/ts/httpStatusCode";
    import { app } from "@/guiide/ts/app";
    import { getAgeNow, round } from "@/guiide/ts/utilities";
    import { useStore } from "vuex";
    import CashType from "@/guiide/ts/cashType";
    import Monitoring from "@/guiide/ts/monitoring/monitoring";

    const minEligibleAge = 55;
    
export default /*@__PURE__*/_defineComponent({
  __name: 'EquityRelease',
  setup(__props) {

    const store = useStore();
    const currentValueInput = ref(null);
    const currentValueModel = ref<number | null>(null);
    const percentage = ref<number | null>(null);
    const fundsAvailable = ref<string>("");
    const showCalcResult = ref<boolean>(false);

    const currentAge = computed<number | null>(() => getAgeNow());
    const isOfEligibleAge = computed<boolean>(() => currentAge.value != null && currentAge.value > minEligibleAge);

    const plannedEquityReleaseAmount = computed<number>(() => {
        const cash = store.state.retiree?.otherCash;
        if (cash == null || cash.length == 0) {
            return 0;
        }

        const equityReleaseCashItems = cash.filter(c => c.cashType == CashType.EquityRelease);

        if (equityReleaseCashItems.length == 0) {
            return 0;
        }

        return equityReleaseCashItems[0].amount;
    });

    const hasIncludedEquityReleaseInPlan = computed<boolean>(() => plannedEquityReleaseAmount.value > 0);

    const whenBorrowingMayOccur = computed<string>(() => {
        return isOfEligibleAge.value ? "currently" : `at age ${minEligibleAge}`;
    });

    async function onCalculatePotentialRelease() {
        if (currentAge.value == null) {
            return;
        }

        if (!currentValueInput.value.isValid()) {
            return;
        }

        if (percentage.value != null) {
            updateCalculatedValue();
            return;
        }

        const ageToUse = Math.max(minEligibleAge, currentAge.value);
        const rateResponse: EquityReleaseRateResponse = await app.getEquityReleaseRate(ageToUse);

        if (rateResponse.status === HttpStatusCode.Ok) {
            percentage.value = rateResponse.percentage;
            updateCalculatedValue();
            showCalcResult.value = true;
        }
    }

    function updateCalculatedValue() {
        const amount = round(currentValueModel.value * percentage.value, 100);
        fundsAvailable.value = formatter.formatCurrency(amount);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[14] || (_cache[14] = _createElementVNode("header", { class: "text-center mb-4" }, [
      _createElementVNode("h2", { class: "skin-page-heading" }, "Equity Release")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("p", null, [
          _createElementVNode("strong", null, "What is Equity Release?")
        ], -1)),
        _createElementVNode("p", null, "If you are " + _toDisplayString(minEligibleAge) + " or over, equity release is simply a way of unlocking the value of your property and turning it into tax-free cash. Think of it as a loan that's repaid using your home once you pass away or require long-term care. Equity release is often taken through what's called a lifetime mortgage."),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, "Many people who want to access some equity in their home to support their retirement income don't want to sell and downsize. You don't have to sell your home or move out with a lifetime mortgage, but it can provide additional regular payments or a lump sum to support your retirement income.", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, "To be clear taking out equity release will reduce the amount of inheritance you leave behind.", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mt-4" }, [
          _createElementVNode("strong", null, "Advice")
        ], -1)),
        _cache[11] || (_cache[11] = _createElementVNode("p", null, "You must speak with a specialist equity release adviser before taking out equity release. It's a big decision, and you need to be aware of all the facts so you can decide if it's right for you.", -1)),
        _cache[12] || (_cache[12] = _createElementVNode("p", null, "We're not encouraging borrowing, or saying it's the right solution, we're just helping you to understand your options.", -1)),
        (!isOfEligibleAge.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "alert-heading" }, [
                _createElementVNode("i", { class: "bi bi-exclamation-circle text-muted fs-5 me-1" }),
                _createTextVNode(" Age warning ")
              ], -1)),
              _createElementVNode("p", { class: "mb-0" }, " Equity release is not available until you are at least " + _toDisplayString(minEligibleAge) + ". The calculate button will show the equity that could be released for someone who is age " + _toDisplayString(minEligibleAge) + ". ")
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: "alert alert-warning mb-0",
                role: "alert"
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "alert-heading" }, [
                  _createElementVNode("i", { class: "bi bi-exclamation-circle text-muted fs-5 me-1" }),
                  _createTextVNode(" Joint home ownership ")
                ], -1)),
                _createElementVNode("p", { class: "mb-0" }, " Do you own your house jointly with someone under the age of " + _toDisplayString(minEligibleAge) + "? If you do, you won't be able to take out equity release until both home owners are over " + _toDisplayString(minEligibleAge) + ". ")
              ]),
              (hasIncludedEquityReleaseInPlan.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, "You can use the calculator below to see whether it could be possible to borrow the " + _toDisplayString(_unref(formatter).formatCurrency(plannedEquityReleaseAmount.value)) + " you have included in your plan.", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_5, "You haven't added any to your plan at the moment, but let's see what it may be possible to borrow."))
            ], 64)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "What is your home's current estimated value?", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(NumberInput, {
                ref_key: "currentValueInput",
                ref: currentValueInput,
                modelValue: currentValueModel.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentValueModel).value = $event)),
                description: "current value",
                max: 4000000
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: onCalculatePotentialRelease,
              class: "btn px-3 btn-secondary"
            }, " Calculate ")
          ])
        ]),
        (showCalcResult.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", null, [
                _cache[4] || (_cache[4] = _createTextVNode("Based on some high level calculations using current rates provided to us you may be able to release up to ")),
                _createElementVNode("strong", null, _toDisplayString(fundsAvailable.value), 1),
                _createTextVNode(" in equity " + _toDisplayString(whenBorrowingMayOccur.value) + ", or perhaps more at another later date.", 1)
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "The figure above assumes you have no remaining mortgage on your home. You can get more accurate figures considering payments needed to clear any outstanding mortgage from any adviser you choose to take advice with.", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "We do not receive any referral fees if you decide to take advice from any adviser.", -1))
            ]))
          : _createCommentVNode("", true),
        _cache[13] || (_cache[13] = _createStaticVNode("<p class=\"mt-4\"><img src=\"/Content/images/Providers/lv-logo.png\" width=\"160\" alt=\"LV= Logo\"></p><p class=\"mt-3\"><strong>Where can I get this advice?</strong></p><p>To advise you on whether equity release may be right for you and which type is best for your circumstances, we&#39;ve partnered with LV=.</p><p>They can provide you with a whole of market Equity Release advice service. Everything they do at LV= is focused on giving you honest advice and finding you a suitable Equity Release plan with a fast and friendly service.</p><p>They can also help with wider advice around your whole retirement plans if needed.</p><p class=\"mt-4\"><strong>Want to learn more?</strong></p><p>To <a href=\"https://www.lv.com/mkt/guiide?utm_source=guiide&amp;utm_medium=website&amp;utm_campaign=guiide_referral&amp;utm_content=guiide_p_one\" target=\"_blank\">find out how much equity you could release</a> call the experts at LV= today.</p><p>0800 023 2956 - Lines open: 9am to 5pm Monday to Friday</p><p>TextDirect: First dial 18001</p><p>LV= may record and / or monitor calls for training and audit purposes.</p><p class=\"mt-5\"><small> Disclaimer - Please note we do not receive any referral fees or commission from LV should you choose to take advice from them. Like some of our other partners, they license our technology so we do have other commercial arrangements with them. </small></p>", 11))
      ])
    ])
  ], 64))
}
}

})